// extracted by mini-css-extract-plugin
export default {"strip":"usZNd","root":"+uo5K","logo":"xqPRy","title":"_6spFV","subTitle":"q0z98","returnTerm":"ZsAPC","noPremiumBanner":"_13-dN","premiumBanner":"GFUnv","icon":"_9hqJc"};